import { render, staticRenderFns } from "./LandingPagePanel.vue?vue&type=template&id=b78da77e&scoped=true"
import script from "./LandingPagePanel.vue?vue&type=script&lang=js"
export * from "./LandingPagePanel.vue?vue&type=script&lang=js"
import style0 from "./LandingPagePanel.vue?vue&type=style&index=0&id=b78da77e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78da77e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b78da77e')) {
      api.createRecord('b78da77e', component.options)
    } else {
      api.reload('b78da77e', component.options)
    }
    module.hot.accept("./LandingPagePanel.vue?vue&type=template&id=b78da77e&scoped=true", function () {
      api.rerender('b78da77e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/controlPanel/landingPage/LandingPagePanel.vue"
export default component.exports